<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="TitleLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="TitleLabel" style="margin-bottom: 0">
          {{ title }}
        </h2>
        <a class="btn btn-close" aria-label="Close" (click)="cancel()"></a>
      </div>
      <form [formGroup]="form" class="modal-body d-grid gap-2">
        <!-- Upload Progress View -->
        @if (submitting) {
          <div class="d-grid gap-2">
            <h4>Upload Progress</h4>
            <div class="list-group">
              <!-- Iterate through all scenes and their files to show upload status -->
              @for (scene of scenes.controls; track scene; let sceneIndex = $index) {
                @for (fileGroup of getSceneFiles(sceneIndex)?.controls; track fileGroup) {
                  <div
                    class="list-group-item d-flex justify-content-between align-items-center">
                    @if (fileGroup) {
                      <span class="d-flex justify-content-between align-items-center w-100">
                        <div class="d-flex align-items-center">
                          <!-- Progress Icons -->
                          <span class="text-center me-2">
                            @if (fileGroup.get('status').value === 'uploading') {
                              <i
                              class="fa spinner-border spinner-border-sm text-primary" role="status"></i>
                            }
                            @if (fileGroup.get('status').value === 'success') {
                              <i class="fas fa-check text-success"></i>
                            }
                            @if (fileGroup.get('status').value === 'pending') {
                              <i class="fas fa-cloud-upload"></i>
                            }
                            @if (fileGroup.get('status').value === 'error') {
                              <i class="fas fa-times text-danger"></i>
                            }
                          </span>
                          <!-- File Type Icon -->
                          <span class="text-center me-2">
                      <i [class]="
                          getFileIconClass(fileGroup.get('file').value.name)
                        " style="width: 20px"></i>
                          </span>
                          {{ scene.get("title").value }}
                        </div>
                        <span class="text-muted ms-auto d-inline-block text-truncate"
                          [attr.title]="fileGroup.get('file').value.name">
                          {{ fileGroup.get('file').value.name }}
                          @if (fileGroup.get('file').value.name.length > 40) {
                            <i class="fas fa-info-circle ms-1"></i>
                          }
                        </span>
                      </span>
                    }
                  </div>
                }
              }
            </div>
          </div>
        }

        <!-- Show file upload form when not submitting -->
        @if (!submitting) {
          <div class="d-grid gap-2">
            <!-- File Upload Zone -->
            <shared-file-dropzone [acceptedFileTypes]="allFileTypes.join(',')" (filesSelected)="handleFiles($event)">
            </shared-file-dropzone>
            <!-- Warning Message -->
            @if (limitWarning) {
              <div class="alert alert-warning" role="alert">
                {{ limitWarning }}
                @if (canAccessBilling) {
                  <button class="btn btn-sm btn-outline-primary ms-2" (click)="navigateToBilling()">
                    Manage Limits
                  </button>
                }
              </div>
            }
            <!-- Project Title Input -->
            <div>
              <label for="projectTitle" class="form-label">Project Title</label>
              <input type="text" id="projectTitle" formControlName="projectTitle" class="form-control" [maxlength]="50"
                [class.is-invalid]="projectTitle.invalid && projectTitle.touched" [readonly]="submitting" />
                @if (projectTitle.invalid) {
                  <div class="invalid-feedback">
                    Project title is required.
                  </div>
                }
              </div>
              <!-- Scenes Section -->
              @if (scenes.length > 0) {
                <div formArrayName="scenes">
                  <label class="form-label">Scenes</label>
                  @for (scene of scenes.controls; track scene; let sceneIndex = $index) {
                    <div [formGroupName]="sceneIndex"
                      class="border rounded p-3 mb-3">
                      <!-- Scene Title and Type Row -->
                      <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center">
                          <label [for]="'sceneTitle' + sceneIndex" class="form-label mb-0">
                            @if (scene.get('type').value == 'virtualTour') {
                              <span class="modal-title">
                                Virtual Tour
                              </span>
                            }
                            @if (scene.get('type').value == 'map') {
                              <span> Map </span>
                            }
                            @if (scene.get('type').value == 'standard') {
                              <span>
                                Standard
                              </span>
                            }
                            Scene Title
                          </label>
                          <button type="button" class="btn btn-link text-dark p-0" (click)="removeScene(sceneIndex)">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                        <!-- Scene Title and File Name -->
                        <div class="d-flex align-items-center mt-2">
                          <div class="col-8 pe-2">
                            <input type="text" [id]="'sceneTitle' + sceneIndex" formControlName="title" class="form-control"
                      [class.is-invalid]="
                        scene.get('title').invalid && scene.get('title').touched
                      " />
                              @if (scene.get('title').invalid) {
                                <div class="invalid-feedback">
                                  Scene title is required.
                                </div>
                              }
                            </div>
                            <div class="col-4 text-end">
                              @if (getSceneFiles(sceneIndex)?.controls[0]?.get('file').value) {
                                <span
                                  class="d-inline-block text-truncate"
                                  [attr.title]="getSceneFiles(sceneIndex).controls[0].get('file').value.name">
                                  {{ getSceneFiles(sceneIndex).controls[0].get('file').value.name }}
                                  @if (getSceneFiles(sceneIndex).controls[0].get('file').value.name.length > 40) {
                                    <i
                                    class="fas fa-info-circle ms-1"></i>
                                  }
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </form>
          <div class="modal-footer">
            @if (!submitting) {
<button type="button" class="btn" [ngClass]="{
          'btn-primary': submitColor == 'blue' || submitColor == null,
          'btn-success': submitColor == 'green',
          'btn-danger': submitColor == 'red',
          'btn-warning': submitColor == 'yellow'
        }" (click)="submit()" [disabled]="scenes?.length == 0 || limitWarning">
                {{ submitText }}
              </button>
            }
            <button type="button" class="btn btn-secondary" (click)="cancel()">
              <span> Close </span>
            </button>
          </div>
        </div>
      </div>
    </div>